import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JsonResponseSingle } from '../models/json-response.interface';
import { SignatoryBasicInfo } from '../models/signatory-basic-info.model';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyBasicInfoResolver implements Resolve<JsonResponseSingle<SignatoryBasicInfo> | null> {

  constructor(private api:ApiService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JsonResponseSingle<SignatoryBasicInfo> | null> {
    return this.api.getSignatoryBasicInfo(route.queryParamMap.get('signatory_uuid') as string).pipe(
      // Si el firmante no existe / error de red, no cancelamos la navegación:
      // resolvemos a null para que la landing muestre el estado de error.
      catchError(() => of(null))
    );
  }
}
